export default __webpack_public_path__ + "fonts/e36bef689f9b51979dd19b0eee8a6cae5ae60941b5262ada2c0aadbb4e934933.ttf";